/** Página institucional dos documentos legais (077). */
export const LEGAL_PATH = '/legal';
export const LEGAL_TERMS_HASH = 'termos';
export const LEGAL_PRIVACY_HASH = 'privacidade';

/** Precisa coincidir com `CURRENT_LEGAL_DOCUMENTS_VERSION` no servidor. */
export const CURRENT_LEGAL_DOCUMENTS_VERSION = '2026-09-09';

export function legalTermsPath(): string {
  return `${LEGAL_PATH}#${LEGAL_TERMS_HASH}`;
}

export function legalPrivacyPath(): string {
  return `${LEGAL_PATH}#${LEGAL_PRIVACY_HASH}`;
}
